/* SeoulSend — shared data loader + renderers
   Data lives in Shopify Files (seoulsend-content-products|brands|reviews.json), written by the ops console
   (tab 21) and admin.seoulsend.com. Every list is shown newest first (idx descending).

   2026-10-12 — moved from cdn.seoulsend.com/content/*.json (S3) to Shopify Files.
   - The section settings may still say https://cdn.seoulsend.com/content/<name>.json — resolve() maps those
     three to the Shopify file, so no theme-editor change is needed. A Shopify file URL in the setting also works.
   - Saving deletes the file and re-creates it under the same name, so the path never changes. Shopify's CDN caches
     a file for a year per exact URL and only honours ?v= as part of the cache key (?t= etc. are ignored), so we
     read with ?v=<current minute>: new content shows up within a minute, and each minute is still cached.
   - If that read fails (e.g. the few seconds between delete and re-create), retry once with a fresh ?v=,
     then fall back to the old S3 file so the section never renders empty. */
(function () {
  if (window.SSData) return;

  var cache = {};

  // UI strings come from the theme locale files (window.SSI18n is set in layout/theme.liquid),
  // so they follow the storefront language. English fallbacks only.
  var i18n = window.SSI18n || {};
  function t(key, fallback) { return i18n[key] || fallback; }

  var SHOPIFY_FILES = 'https://cdn.shopify.com/s/files/1/0745/6437/0595/files/';
  var MOVED = /^https:\/\/cdn\.seoulsend\.com\/content\/(products|brands|reviews)\.json(?:[?#].*)?$/;

  // Old S3 setting → Shopify file. Anything else is used as is.
  function resolve(url) {
    var m = MOVED.exec(String(url).trim());
    return m ? SHOPIFY_FILES + 'seoulsend-content-' + m[1] + '.json' : String(url).trim();
  }
  function withV(url, v) {
    return url.replace(/[?#].*$/, '') + '?v=' + v;
  }
  function getJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function load(url) {
    if (!url) return Promise.reject(new Error('No data URL'));
    if (!cache[url]) {
      var real = resolve(url);
      var isShopify = real.indexOf('https://cdn.shopify.com/') === 0;
      var first = isShopify ? withV(real, 'm' + Math.floor(Date.now() / 60000)) : real;
      var p = getJson(first);
      if (isShopify) {
        p = p.catch(function () {
          return wait(2500).then(function () { return getJson(withV(real, 'r' + Date.now())); });
        });
        if (real !== String(url).trim()) {
          p = p.catch(function () { return getJson(url); });   // last resort: the old S3 file
        }
      }
      cache[url] = p
        .then(function (list) {
          if (!Array.isArray(list)) return [];
          return list.slice().sort(function (a, b) {
            return (Number(b && b.idx) || 0) - (Number(a && a.idx) || 0);
          });
        })
        .catch(function (e) {
          delete cache[url]; // allow retry on next call
          throw e;
        });
    }
    return cache[url];
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeUrl(u) {
    u = String(u || '').trim();
    return /^https?:\/\//i.test(u) ? u : '';
  }

  // Outbound links to brand stores carry ?from=seoulsend (or &from=seoulsend when a query exists).
  // Keeps any #hash at the end. Does nothing for an empty URL or one that already has `from`.
  function withFrom(u) {
    if (!u) return '';
    var hash = '';
    var i = u.indexOf('#');
    if (i > -1) { hash = u.slice(i); u = u.slice(0, i); }
    if (/[?&]from=/.test(u)) return u + hash;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'from=seoulsend' + hash;
  }

  // Cafe24 stores serve the same image at /tiny/ /small/ /medium/ /big/.
  // Prefer the big one for the 4:5 card; fall back to the original if it 404s.
  function bigImage(u) {
    return u.replace(/\/web\/product\/(tiny|small|medium)\//, '/web/product/big/');
  }

  function productCard(p) {
    var href = withFrom(safeUrl(p.product_url));
    var img = safeUrl(p.img_url);
    var big = img ? bigImage(img) : '';
    var brand = esc(p.brand_name);
    var name = esc(p.product_name);
    // Optional sold-out flag (not in the feed yet): sold_out / soldout / is_sold_out truthy → greyed card, no link.
    var soldOut = !!(p.sold_out || p.soldout || p.is_sold_out);
    if (soldOut) href = '';
    var tag = href ? 'a' : 'div';
    var attrs = href ? ' href="' + esc(href) + '" target="_blank" rel="noopener"' : '';
    return (
      '<li><' + tag + ' class="ss-card' + (soldOut ? ' ss-card--soldout' : '') + '"' + attrs + '>' +
        '<div class="ss-card__media ss-ph">' +
          (img
            ? '<img src="' + esc(big) + '" data-fallback="' + esc(img) + '" alt="' + brand + ' ' + name + '" loading="lazy" decoding="async" onerror="if(this.dataset.fallback&&this.src!==this.dataset.fallback){this.src=this.dataset.fallback;}else{this.remove();}">'
            : '') +
          (soldOut ? '<span class="ss-card__soldout">' + esc(t('sold_out', 'Sold out')) + '</span>' : '') +
        '</div>' +
        '<div class="ss-card__meta">' +
          '<div class="ss-card__brand"><span>' + brand + '</span></div>' +
          '<div class="ss-card__name">' + name + '</div>' +
        '</div>' +
      '</' + tag + '></li>'
    );
  }

  function placeholderCards(n) {
    var out = '';
    for (var i = 0; i < n; i++) {
      out +=
        '<li aria-hidden="true"><div class="ss-card">' +
          '<div class="ss-card__media ss-ph"></div>' +
          '<div class="ss-card__meta"><div class="ss-card__brand"><span>&nbsp;</span></div><div class="ss-card__name">&nbsp;</div></div>' +
        '</div></li>';
    }
    return out;
  }

  window.SSData = {
    load: load,
    esc: esc,
    safeUrl: safeUrl,
    withFrom: withFrom,
    productCard: productCard,
    placeholderCards: placeholderCards
  };
})();
